"use client";

import { Instagram, Linkedin, MapPin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
const offices = [{
  city: "Irving",
  country: "TX",
  lat: "32.8140 N",
  lng: "96.9489 W"
}];
const socialLinks = [{
  label: "Instagram",
  href: "https://www.instagram.com/sultanigrill",
  icon: "instagram"
}];
const accreditationBadges = [{
  label: "Halal Certified",
  code: "HALAL"
}, {
  label: "Zabiha",
  code: "ZABIHA"
}, {
  label: "Fresh Daily",
  code: "FRESH"
}];
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div data-section-id="232308" className="flex flex-col gap-2">
        {[1, 2, 3, 4].map((_, i) => <div data-index={i} key={i} className="h-4 w-24 bg-muted animate-pulse" />)}
      </div>;
  }
  return <ul className="flex flex-col gap-2">
      {menuItems.map((item, i) => <li data-index={i} key={item.id}>
          <Link to={item.href || "#"} className="text-sm font-default text-foreground/70 hover:text-primary transition-colors duration-200 uppercase tracking-widest">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const lastUpdate = new Date().toISOString().replace("T", " ").slice(0, 19) + " UTC";
  return <section id="footer" className="bg-background text-foreground">
      {}
      <div className="h-1 w-full bg-primary" />

      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">

          {}
          <div className="flex flex-col gap-6">
            <Link to="/">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1648254/img/sultani_grill_logo_dark.png" alt="Sultani Grill & Burgers" className="h-7" />
            </Link>
            <p className="text-sm font-default text-muted-foreground leading-relaxed">
              Halal Punjabi-American fusion. From smash burgers to karahi, we bring bold flavors to Irving, TX.
            </p>
            <div className="flex flex-col gap-2">
              <p className="text-xs font-mono text-secondary uppercase tracking-widest mb-1">Our Standards</p>
              <div className="flex flex-wrap gap-2">
                {accreditationBadges.map((badge, i) => <span data-index={i} key={badge.code} className="inline-flex items-center px-2 py-1 text-xs font-mono border border-border text-muted-foreground hover:border-primary hover:text-primary transition-colors duration-200">
                    {badge.code}
                  </span>)}
              </div>
            </div>
          </div>

          {}
          <div className="flex flex-col gap-4">
            <h4 className="font-default text-xs uppercase tracking-widest text-secondary font-bold">
              Quick Links
            </h4>
            <MenuProvider menu_id="40">
              <FooterMenuConsumer />
            </MenuProvider>
            <div className="mt-2 border-l-2 border-primary pl-4">
              <Link to="#" className="text-sm font-default text-primary hover:text-primary/80 transition-colors uppercase tracking-widest">
                View Menu
              </Link>
            </div>
          </div>

          {}
          <div className="flex flex-col gap-4">
            <h4 className="font-default text-xs uppercase tracking-widest text-secondary font-bold">
              Visit Us
            </h4>
            <ul className="flex flex-col gap-5">
              {offices.map((office, i) => <li data-index={i} key={office.city} className="flex flex-col gap-1">
                  <div className="flex items-center gap-1.5">
                    <MapPin className="size-3 text-primary shrink-0" />
                    <span className="text-sm font-default font-semibold text-foreground">
                      2851 Esters Rd, {office.city}, {office.country}
                    </span>
                  </div>
                  <div className="ml-4.5 flex flex-col gap-0.5">
                    <a href="tel:972-600-9309" className="font-mono text-xs text-muted-foreground hover:text-primary transition-colors">
                      972-600-9309
                    </a>
                  </div>
                </li>)}
            </ul>
          </div>

          {}
          <div className="flex flex-col gap-4">
            <h4 className="font-default text-xs uppercase tracking-widest text-secondary font-bold">
              Connect
            </h4>
            <div className="flex flex-col gap-3">
              {socialLinks.map((social, i) => <Link data-index={i} key={social.label} to={social.href} newTab className="group flex items-center gap-3 text-muted-foreground hover:text-primary transition-colors duration-200">
                  <div className="flex items-center justify-center size-9 border border-border group-hover:border-primary transition-colors duration-200 bg-card">
                    {social.icon === "linkedin" ? <Linkedin className="size-4" /> : <Instagram className="size-4" />}
                  </div>
                  <span className="text-sm font-mono uppercase tracking-widest">{social.label}</span>
                </Link>)}
            </div>

            <div className="mt-6 p-4 border border-border bg-card">
              <p className="font-mono text-xs text-secondary uppercase tracking-widest mb-1">Instagram</p>
              <Link to="https://www.instagram.com/sultanigrill" newTab className="font-mono text-xs text-primary hover:text-primary/80 transition-colors">
                @sultanigrill
              </Link>
            </div>
          </div>
        </div>

        {}
        <Separator className="my-10 bg-border" />

        {}
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-6">
            <p className="text-xs font-default text-muted-foreground">
              &copy; {new Date().getFullYear()} Sultani Grill & Burgers. All rights reserved.
            </p>
            <div className="flex items-center gap-4">
              <Link to="#" className="text-xs font-default text-muted-foreground/50 hover:text-foreground transition-colors">
                Privacy Policy
              </Link>
              <Link to="#" className="text-xs font-default text-muted-foreground/50 hover:text-foreground transition-colors">
                Terms of Use
              </Link>
            </div>
          </div>

          {}
          <div className="flex items-center gap-2">
            <div className="size-1.5 rounded-full bg-primary animate-pulse" />
            <span className="font-mono text-xs text-muted-foreground/50 uppercase tracking-widest">
              Kitchen Status:
            </span>
            <span className="font-mono text-xs text-primary/70">
              Open Now
            </span>
          </div>
        </div>
      </div>
    </section>;
}